import React,{useEffect,useState} from 'react';
import axios from 'axios';
import shuffle from '../utils/shuffle';
import swal from 'sweetalert';
import thanks from "../img/thanks.png"
import { Link } from 'react-router-dom';
const Questions = () => {

    const [savol,setSavol] = useState([]);
    const [savolNum, setSavolNum] = useState(0);
    const [doneQuest, setDoneQuest] = useState([]);
    const [ball, setBall] = useState([]);
    const [result, setResult] = useState(false);
    let nextSavol = 0;
    // =================API=================== //
    useEffect(() => {
        axios.post("https://tadqiqot-sorovnoma.uz/javohir/surovnoma.uz/admin/Api/quest.php",{
        })
        .then(function (response) { 
            setSavol(response.data); 
            console.log(response.data);  
        })
        .catch(function (error) { 
            console.log(error);
        });   
    },[]);

    useEffect(() => {
        if(savol.length){
            let filQuest = [];
            savol.map(item => {
                if(filQuest.length <5){
                    filQuest.push(item);
                }
            })
            setDoneQuest(filQuest);
            console.log(doneQuest);
        }
    },[savol])

    let isCorrect = (e) => {
        
        if(savolNum<doneQuest.length-1){
            setSavolNum(savolNum + 1);
            console.log(savolNum);
            console.log(doneQuest.length);
        }else{
            setResult(true)
        }
        
        // console.log(e.target.value);

    }
    // =================API=================== //
    return ( 
        <div className='questions'>
            <section className='question_section blur flex center'>
                {
                    result?(
                        <div className='question_box flex center border-none'>
                            <img className='thanks-img' src={thanks} />
                            <h1 className='bigger-font'>Ishtirokingiz uchun rahmat!</h1>
                            <Link to="/">
                                <button className='btn btn-succses medium-font-size'>Bosh sahifa</button>
                            </Link>
                        </div>

                    ):(
                        <>
                            { 
                            doneQuest[savolNum]?.savol?(
                                <>
                                    <div className='question_box'>
                                        <h2>{doneQuest[savolNum].savol}</h2>
                                        {    
                                            shuffle(doneQuest[savolNum].variant).map((varr)=>
                                            <div className='checkedVariants' key={varr.id}>
                                                    <label >
                                                        <input
                                                            name="isGoing"
                                                            type="checkbox"
                                                            onChange={isCorrect}
                                                            value={varr.status}
                                                        />
                                                        {varr.name} 
                                                    </label>
                                                </div>
                                            )
                                        }
                                    </div>
                                </>
                            ):(
                                <>Loanding...</>
                            )
                        }
                        </>
                    )
                }
            </section>
        </div>
    );
};
export default Questions;